import contentfulGql from 'js/lib/contentfulGql';

import { entWebsiteBlockAssemblyIdTypeOnlyFragment } from 'bundles/ent-website/queries/EntWebsiteBlockAssembly';
import { entWebsiteNativeDataSourceFragment } from 'bundles/ent-website/queries/EntWebsiteNativeDataSource';
import { imageFragment } from 'bundles/ent-website/queries/common';

/**
 * Page-level queries
 */

export const pageAssemblyQuery = contentfulGql`#graphql
  ${imageFragment}
  ${entWebsiteBlockAssemblyIdTypeOnlyFragment}
  ${entWebsiteNativeDataSourceFragment}
  query PageAssemblyQuery($slug: String!, $domain: String!, $preview: Boolean, $locale: String!) {
    entWebsitePageAssemblyCollection(where: { slug: $slug, domain_contains_some: [$domain] }, limit: 1, preview: $preview, locale: $locale) {
      items {
        slug
        title 
        seoDescription
        seoTitle
        seoImage {
          ...Image
        }
        seoCanonical
        preventSearchEngine
        dataSourcesCollection(limit: 5) {
          items {
            ...EntWebsiteNativeDataSource
          }
        }
        blocksCollection(limit: 16) {
          items {
            ...EntWebsiteBlockAssemblyIdTypeOnly,
            experimentName
            experimentValue
          }
        }
      }
    }
  }
`;
